import Guid from "_shared/guids/guid";
import EntityName from "legal-entities/entity-names/entity-name";
import RegistrationInfo from "legal-entities/registration-info/registration-info";
import InvitationMessage from "legal-entities/invitations/messages/invitation-message";
import { InvitationStatus } from "legal-entities/invitations/statuses/invitation-status";
import EntityOfficerInvitationSchema, { 
  EntityOfficerInvitationJSON, 
  EntityOfficerInvitationParams 
} from "legal-entities/invitations/officer-invitations/_schema/entity-officer-invitation-schema";
import Entity from "_framework/entities/entity";

export default class EntityOfficerInvitation extends Entity<EntityOfficerInvitation, EntityOfficerInvitationJSON,EntityOfficerInvitationParams> {
  public static create(args: { params: EntityOfficerInvitationParams, options?: { silenceSchemaErrors: boolean } }): EntityOfficerInvitation {
    const parsed = EntityOfficerInvitationSchema.validate(args.params, !args.options?.silenceSchemaErrors);
    return new EntityOfficerInvitation(parsed);
  }

  public static fromJSON(json: EntityOfficerInvitationJSON): EntityOfficerInvitation {
    const parsed = EntityOfficerInvitationSchema.deserialize(json);
    return new EntityOfficerInvitation(parsed);
  }

  public static fromJSONArray(
    jsonArray: EntityOfficerInvitationJSON[]
  ): EntityOfficerInvitation[] {
    if (!Array.isArray(jsonArray) || jsonArray.length === 0) return [];
    return jsonArray.map(json => EntityOfficerInvitation.fromJSON(json));
  }

  public readonly id?: Guid; // TODO: Not undefined-able? in the server-side EntityOfficerInvitation class.
  // TODO: Missing the "userId: Guid" field.
  public readonly entityName: EntityName;
  public readonly registrationInfo: RegistrationInfo; // TODO: Does not exist in the server-side EntityOfficerInvitation class.
  public readonly message?: InvitationMessage;
  public readonly status: InvitationStatus;

  public constructor(params: EntityOfficerInvitationParams) {
    super(params);
    this.id = params.id;
    this.entityName = params.entityName;
    this.registrationInfo = params.registrationInfo instanceof RegistrationInfo
      ? params.registrationInfo
      : RegistrationInfo.create(params.registrationInfo);
    this.message = params.message;
    this.status = params.status ?? InvitationStatus.Open;
  }

  public toJSON(): EntityOfficerInvitationJSON {
    return EntityOfficerInvitationSchema.serialize(this);
  }
  
  public valueOf(): EntityOfficerInvitationJSON {
    return this.toJSON();
  }

  public isEqualTo(other: EntityOfficerInvitation | null | undefined): boolean {
    return this.id?.isEqualTo(other?.id ?? null) ?? false;
  }

  public toString(): string {
    return `EntityOfficerInvitation {
      id: ${this.id}
      entityName: ${this.entityName}
      registrationInfo: ${this.registrationInfo}
      message: ${this.message}
      status: ${this.status}
    }`;
  }
}

export class EntityOfficerInvitationNotFoundError extends Error {
  constructor(id: Guid) {
    super(`Unable to find invitation by id: ${id}`);
  }
}
export class UnauthorizedEntityOfficerInvitationAccessError extends Error {
  constructor() {
    super("You are not permitted to view all open officer invitations.");
  }
}
export class InvalidEntityOfficerInvitationError extends Error { }
export class InvalidEntityOfficerInvitationStatusError extends Error { }